<template>
  <div id="ElectricMonitor">
    <energy-organize @changeNode="changeNode" :treeData="treeData" @setTree="setTree" :type='2'></energy-organize>
    <div class="content">
      <!-- 分组 -->
      <div class="organize-view" v-show="treeObj.type==1">
        <div class="type-box">
          <div :class="{'active':active == 1}" @click="active=1">
            <span>设备列表</span>
          </div>
          <div :class="{'active':active == 2}" @click="active=2">
            <span>数据详情</span>
          </div>
        </div>
        <div class="device-list-content" v-show="active==1">
          <div class="btn-box2">
            <el-button type="primary" size="medium" @click="selecting=true" v-show="!selecting">选择</el-button>
            <el-button size="medium" style="margin-left: 0;" @click="selecting=false" v-show="selecting">取消</el-button>
            <el-button type="primary" size="medium" :disabled="checkedArr.length==0" @click="clickSetGroup">改变分组
            </el-button>
          </div>
          <div class="device-list">
            <div class="item" v-for="(item,i) in dataList" @click="clickDevice(item)">
              <p class="item-title"><span></span>{{item.name}}
                <el-checkbox @change="changeDevice(item.code)" class="f-r" :checked="checkedArr.includes(item.code)"
                  v-if="selecting"></el-checkbox>
              </p>
              <div class="details clearfix">
                <div class="f-l">
                  <img class="img" src="../../assets/image/energy/electric.png">
                </div>
                <div class="f-l text t-hide">{{item.groupId?item.groupName:'默认组'}}</div>
              </div>
            </div>
          </div>
          <!-- 没有列表数据 -->
          <div class="nullDataBox" v-show="dataList.length==0">
              <img :src="nullData" class="nullData">
              <span>什么东西都没有找到...</span>
          </div>
        </div>
        <div class="data-details" v-show="active==2">
          <div class="top-box">
            <div>
              <p class="attr-title">功率</p>
              <p class="attr">
                正向有功功率：{{EnergyData.CurrentForwardATE==null?"--":EnergyData.CurrentForwardATE.toFixed(1)}} <!-- bigNumberTransform(EnergyData.CurrentForwardATE,8) -->
                <!-- <span class="num-unit">{{getUnit(EnergyData.CurrentForwardATE)}}</span> -->
                <span v-if="EnergyData.CurrentForwardATE!=null">kW</span></p>
              <p class="attr">
                无功功率：{{EnergyData.TotalReactivePower==null?"--":EnergyData.TotalReactivePower.toFixed(1)}}
                <!-- <span class="num-unit">{{getUnit(EnergyData.TotalReactivePower)}}</span> -->
                <span v-if="EnergyData.TotalReactivePower!=null">KVA</span></p>
              <p class="attr">
                视在功率：{{EnergyData.TotalApparentPower==null?"--":EnergyData.TotalApparentPower.toFixed(1)}}
                <!-- <span class="num-unit">{{getUnit(EnergyData.TotalApparentPower)}}</span> -->
                <span v-if="EnergyData.TotalApparentPower!=null">kW</span></p>
            </div>
            <div>
              <p class="attr-title">电流</p>
              <p class="attr">A相电流：{{EnergyData.ElectricityA==null?"--":EnergyData.ElectricityA.toFixed(1)}} <span
                  v-if="EnergyData.ElectricityA!=null">A</span></p>
              <p class="attr">B相电流：{{EnergyData.ElectricityB==null?"--":EnergyData.ElectricityB.toFixed(1)}} <span
                  v-if="EnergyData.ElectricityB!=null">A</span></p>
              <p class="attr">C相电流：{{EnergyData.ElectricityC==null?"--":EnergyData.ElectricityC.toFixed(1)}} <span
                  v-if="EnergyData.ElectricityC!=null">A</span></p>
            </div>
            <div v-if="false"> <!-- 后续确定删除 12.13 -->
              <p class="attr-title">电流畸变</p>
              <p class="attr">A相电流谐波畸变率：{{EnergyData.THDUa==null?"--":floatMultiply(EnergyData.THDUa,1).toFixed(1)}}
              <span v-if="EnergyData.THDUa!=null">%</span></p>
              <p class="attr">B相电流谐波畸变率：{{EnergyData.THDUb==null?"--":floatMultiply(EnergyData.THDUb,1).toFixed(1)}}
              <span v-if="EnergyData.THDUb!=null">%</span></p>
              <p class="attr">C相电流谐波畸变率：{{EnergyData.THDUc==null?"--":floatMultiply(EnergyData.THDUc,1).toFixed(1)}}
              <span v-if="EnergyData.THDUc!=null">%</span></p>
            </div>
            <div v-if="false"> <!-- 后续确定删除 12.13 -->
              <p class="attr-title">电压畸变</p>
              <!-- <div class="scroll-box">
                <p class="attr">正向有功功率</p>
                <p class="attr">无功功率</p>
                <p class="attr">视在功率</p>
                <p class="attr">正向有功功率</p>
                <p class="attr">无功功率</p>
                <p class="attr">视在功率</p>
              </div> -->
              <p class="attr">A相电压谐波畸变率：{{EnergyData.THDIa==null?"--":floatMultiply(EnergyData.THDIa,1).toFixed(1)}} <span
                  v-if="EnergyData.THDIa!=null">%</span></p>
              <p class="attr">B相电压谐波畸变率：{{EnergyData.THDIb==null?"--":floatMultiply(EnergyData.THDIb,1).toFixed(1)}} <span
                  v-if="EnergyData.THDIb!=null">%</span></p>
              <p class="attr">C相电压谐波畸变率：{{EnergyData.THDIc==null?"--":floatMultiply(EnergyData.THDIc,1).toFixed(1)}} <span
                  v-if="EnergyData.THDIc!=null">%</span></p>
            </div>
          </div>
          <!-- 柱状图 -->
          <div class="echart-view">
            <myDatePicker @changeTime="changeTime2" :type="2"></myDatePicker>
            <p class="legend"><span></span>用电量</p>
            <div class="scroll">
              <div id="Category" ref="Category"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 设备 -->
      <div class="device-view" v-show="treeObj.type==2">
        <div class="device-top clearfix">
          <div class="left-box f-l">
            <div class="echars-box" ref="gauge1" id="gauge1"></div>
            <div class="data-box">
              <span>{{getDebtRatio(0)}}</span>
              <span>{{getDebtRatio(1)}}</span>
              <span>{{getDebtRatio(2)}}</span> .
              <span>{{getDebtRatio(3)}}</span>
              <span>{{getDebtRatio(4)}}</span>
            </div>
          </div>
          <div class="right-box f-l">
            <div class="top-charts">
              <div>
                <p>频率</p>
                <div class="chart-box" ref="gauge2" id="gauge2"></div>
                <span class="data-span"><span
                    class="data">{{deviceData.Frequency==null?'--':common.fmoney(deviceData.Frequency,deviceData.Frequencystep)}}</span><span
                    style="font-weight: 400;color: #BABABA;font-size: 16px;"
                    v-show="deviceData.Frequency!=null">{{deviceData.Frequencyunit}}</span></span>
              </div>
              <div>
                <p>功率因数</p>
                <div class="chart-box" ref="gauge3" id="gauge3"></div>
                <span class="data-span"><span
                    class="data gv">{{deviceData.TotalPowerFactor==null?'--':common.fmoney(deviceData.TotalPowerFactor,deviceData.TotalPowerFactorstep)}}</span></span>
              </div>
              <div>
                <p>三相电压不平衡度</p>
                <div class="chart-box" ref="gauge4" id="gauge4"></div>
                <span class="data-span"><span
                    class="data dy">{{deviceData.VoltageImbalance==null?'--':floatMultiply(common.fmoney(deviceData.VoltageImbalance,deviceData.VoltageImbalancestep),1)}}</span>
                  <span v-show="deviceData.VoltageImbalance!=null">{{deviceData.VoltageImbalanceunit}}</span></span>
              </div>
              <div>
                <p>负载率</p>
                <div class="chart-box" ref="gauge5" id="gauge5"></div>
                <span class="data-span"><span
                    class="data dl">{{deviceData.DebtRatio==null?'--':floatMultiply(common.fmoney(deviceData.DebtRatio,0.01),1)}}</span>
                  <span v-show="deviceData.DebtRatio!=null">{{deviceData.DebtRatiounit}}</span></span>
              </div>
            </div>
            <div class="bottom-data">
              <div class="data-title">
                <li class="w-160">负载</li>
                <li class="w-145">电流</li>
                <li class="w-145">电压</li>
                <li class="w-200">温度</li>
                <li class="w-145">总谐波含有率</li>
              </div>
              <div class="data-lab">
                <li class="w-160"><span class="black">额定容量 </span><span class="blue value">-- </span></li>
                <li class="w-145"><span class="yellow">A相 </span><span
                    class="value">{{deviceData.ElectricityA==null?'--':common.fmoney(deviceData.ElectricityA,deviceData.ElectricityAstep)}}</span><span
                    class="unit" v-show="deviceData.ElectricityA!=null"> {{deviceData.ElectricityAunit}}</span></li>
                <li class="w-145"><span class="yellow">Uab </span><span
                    class="value">{{deviceData.VoltageAB==null?'--':common.fmoney(deviceData.VoltageAB,deviceData.VoltageABstep)}}</span><span class="unit"
                    v-show="deviceData.VoltageAB!=null"> {{deviceData.VoltageABunit}}</span></li>
                <li class="w-200"><span class="yellow">A相绕组温度 </span><span
                    class="value">{{deviceData.T1==null?'--':common.fmoney(deviceData.T1,deviceData.T1step)}}</span><span class="unit"
                    v-show="deviceData.T1!=null"> {{deviceData.T1unit}}</span></li>
                <li class="w-145"><span class="yellow">A相电流 </span><span
                    class="value">{{deviceData.THIa==null?'--':floatMultiply(common.fmoney(deviceData.THIa,deviceData.THIastep),1)}}</span><span
                    class="unit" v-show="deviceData.THIa!=null"> {{deviceData.THIaunit}}</span></li>
              </div>
              <div class="data-lab">
                <li class="w-160"><span class="black">视在功率 </span><span
                    class="blue value">{{deviceData.TotalApparentPower==null?'--':common.fmoney(deviceData.TotalApparentPower,deviceData.TotalApparentPowerstep)}}
                  </span><span class="unit" v-show="deviceData.TotalApparentPower!=null"> {{deviceData.TotalApparentPowerunit}}</span></li>
                <li class="w-145"><span class="green">B相 </span><span
                    class="value">{{deviceData.ElectricityB==null?'--':common.fmoney(deviceData.ElectricityB,deviceData.ElectricityBstep)}}</span><span
                    class="unit" v-show="deviceData.ElectricityB!=null"> {{deviceData.ElectricityBunit}}</span></li>
                <li class="w-145"><span class="green">Ubc </span><span
                    class="value">{{deviceData.VoltageCB==null?'--':common.fmoney(deviceData.VoltageCB,deviceData.VoltageCBstep)}}</span><span class="unit"
                    v-show="deviceData.VoltageCB!=null"> {{deviceData.VoltageCBunit}}</span></li>
                <li class="w-200"><span class="green">B相绕组温度 </span><span
                    class="value">{{deviceData.T2==null?'--':common.fmoney(deviceData.T2,deviceData.T2step)}}</span><span class="unit"
                    v-show="deviceData.T2!=null"> {{deviceData.T2unit}}</span></li>
                <li class="w-145"><span class="green">B相电流 </span><span
                    class="value">{{deviceData.THIb==null?'--':floatMultiply(common.fmoney(deviceData.THIb,deviceData.THIbstep),1)}}</span><span
                    class="unit" v-show="deviceData.THIb!=null"> {{deviceData.THIbunit}}</span></li>
              </div>
              <div class="data-lab">
                <li class="w-160"><span class="black">有功功率 </span><span
                    class="blue value">{{deviceData.TotalActivePower==null?'--':common.fmoney(deviceData.TotalActivePower,deviceData.TotalActivePowerstep)}}
                  </span><span class="unit" v-show="deviceData.TotalActivePower!=null"> {{deviceData.TotalActivePowerunit}}</span></li>
                <li class="w-145"><span class="red">C相 </span><span
                    class="value">{{deviceData.ElectricityC==null?'--':common.fmoney(deviceData.ElectricityC,deviceData.ElectricityCstep)}}</span><span
                    class="unit" v-show="deviceData.ElectricityC!=null"> {{deviceData.ElectricityCunit}}</span></li>
                <li class="w-145"><span class="red">Uca </span><span
                    class="value">{{deviceData.VoltageAC==null?'--':common.fmoney(deviceData.VoltageAC,deviceData.VoltageACstep)}}</span><span class="unit"
                    v-show="deviceData.VoltageAC!=null"> {{deviceData.VoltageACunit}}</span></li>
                <li class="w-200"><span class="red">C相绕组温度 </span><span
                    class="value">{{deviceData.T3==null?'--':common.fmoney(deviceData.T3,deviceData.T3step)}}</span><span class="unit"
                    v-show="deviceData.T3!=null"> {{deviceData.T3unit}}</span></li>
                <li class="w-145"><span class="red">C相电流 </span><span
                    class="value">{{deviceData.THIc==null?'--':floatMultiply(common.fmoney(deviceData.THIc,deviceData.THIcstep),1)}}</span><span
                    class="unit" v-show="deviceData.THIc!=null"> {{deviceData.THIcunit}}</span></li>
              </div>
              <div class="data-lab">
                <li class="w-160"><span class="black">无功功率 </span><span
                    class="blue value">{{deviceData.TotalReactivePower==null?'--': common.fmoney(deviceData.TotalReactivePower,deviceData.TotalReactivePowerstep)}}  <!-- bigNumberTransform(deviceData.TotalReactivePower,7) -->
                  </span><span class="unit" v-show="deviceData.TotalReactivePower!=null"> {{deviceData.TotalReactivePowerunit}}</span></li>
                <li class="w-145"></li>
                <li class="w-145"><span class="yellow">Ua </span><span
                    class="value">&nbsp;&nbsp;&nbsp;&nbsp;{{deviceData.VoltageA==null?'--': common.fmoney(deviceData.VoltageA,deviceData.VoltageAstep)}}</span><span
                    class="unit" v-show="deviceData.VoltageA!=null"> {{deviceData.VoltageAunit}}</span>
                </li>
                <li class="w-200"></li>
                <li class="w-145"><span class="yellow">A相电压 </span><span
                    class="value">{{deviceData.THUa==null?'--':floatMultiply(common.fmoney(deviceData.THUa,deviceData.THUastep) ,1)}}</span><span
                    class="unit" v-show="deviceData.THUa!=null"> {{deviceData.THUaunit}}</span></li>
              </div>
              <div class="data-lab">
                <li class="w-160"><span class="black">最大需量 </span><span class="blue value">-- </span></li>
                <li class="w-145"></li>
                <li class="w-145"><span class="green">Ub </span><span
                    class="value">&nbsp;&nbsp;&nbsp;&nbsp;{{deviceData.VoltageB==null?'--':common.fmoney(deviceData.VoltageB,deviceData.VoltageBstep)}}</span><span
                    class="unit" v-show="deviceData.VoltageB!=null"> {{deviceData.VoltageBunit}}</span>
                </li>
                <li class="w-200"></li>
                <li class="w-145"><span class="green">B相电压 </span><span
                    class="value">{{deviceData.THUb==null?'--':floatMultiply(common.fmoney(deviceData.THUb,deviceData.THUbstep),1)}}</span><span
                    class="unit" v-show="deviceData.THUb!=null"> {{deviceData.THUbunit}}</span></li>
              </div>
              <div class="data-lab no-border">
                <li class="w-160"><span class="black">当前电量 </span><span
                    class="blue value">{{deviceData.CurrentForwardATE==null?'--':common.fmoney(deviceData.CurrentForwardATE,deviceData.CurrentForwardATEstep)}}
                  </span><span class="unit" v-show="deviceData.CurrentForwardATE!=null"> {{deviceData.CurrentForwardATEunit}}</span></li>
                <li class="w-145"></li>
                <li class="w-145"><span class="red">Uc </span><span
                    class="value">&nbsp;&nbsp;&nbsp;&nbsp;{{deviceData.VoltageC==null?'--':common.fmoney(deviceData.VoltageC,deviceData.VoltageCstep)}}</span><span
                    class="unit" v-show="deviceData.VoltageC!=null"> {{deviceData.VoltageCunit}}</span>
                </li>
                <li class="w-200"></li>
                <li class="w-145"><span class="red">C相电压 </span><span
                    class="value">{{deviceData.THUc==null?'--':floatMultiply(common.fmoney(deviceData.THUc,deviceData.THUcstep) ,1)}}</span><span
                    class="unit" v-show="deviceData.THUc!=null"> {{deviceData.THUcunit}}</span></li>
              </div>
            </div>

          </div>
        </div>
        <div class="device-bottom clearfix">
          <div class="bottom-left f-l p-r">
            <div class="type-box" style="margin-right: 30px;">
              <div :class="{'active':chartType == 1}" @click="setChartType(1)">
                <span>有功功率</span>
              </div>
              <div :class="{'active':chartType == 2}" @click="setChartType(2)">
                <span>无功功率</span>
              </div>
              <div :class="{'active':chartType == 3}" @click="setChartType(3)">
                <span>视在功率</span>
              </div>
              <div :class="{'active':chartType == 4}" @click="setChartType(4)">
                <span>电压</span>
              </div>
              <div :class="{'active':chartType == 5}" @click="setChartType(5)">
                <span>电流</span>
              </div>
            </div>
            <myDatePicker @changeTime="changeTime3" :type="1"></myDatePicker>
            <div class="bottom-chart" ref="line" id="line"></div>
            <div class="notData" v-show="!nowLineArr.length&&!oldLineArr.length">暂无数据</div>
          </div>
          <div class="bottom-right f-l">
            <div class="data-title l-h-42 bottom-title2">
              <li style="width:49%;">本期</li>
              <li style="width:49%;">时间</li>
            </div>
             <!-- <div class="bottom-data-lab l-h-42">
              <li class="t-hide">最大值
                <span class="value2"> {{getMax(nowLineArr)}}</span>
              </li>
              <li>{{getMaxTime(nowLineArr)}}</li>
            </div>
            <div class="bottom-data-lab l-h-42">
              <li class="t-hide">最小值
                <span class="value2"> {{getMin(nowLineArr)}}</span>
              </li>
              <li>{{getMinTime(nowLineArr)}}</li>
            </div> -->
            <div class="bottom-data-lab l-h-42">
              <li class="t-hide">最大值<span class="value2" :title="getMax(nowLineArr)"> {{bigNumberTransform(getMax(nowLineArr),5)}}</span>
                <span class="num-unit" style="color: #01a6ac;">{{getUnit(getMax(nowLineArr))}}</span></li>
              <li>{{getMaxTime(nowLineArr)}}</li>
            </div>
            <div class="bottom-data-lab l-h-42">
              <li class="t-hide">最小值<span class="value2" :title="getMin(nowLineArr)"> {{bigNumberTransform(getMin(nowLineArr),5)}}</span>
                <span class="num-unit" style="color: #01a6ac;">{{getUnit(getMin(nowLineArr))}}</span></li>
              <li>{{getMinTime(nowLineArr)}}</li>
            </div>
            <div class="bottom-data-lab l-h-42">
              <li class="t-hide" style="width: 90%;">平均值
                <span class="value2" :title="getAvg(nowLineArr)"> {{getAvg(nowLineArr)}}</span>
                <!-- <span class="num-unit" style="color: #01a6ac;">{{getUnit(getAvg(nowLineArr))}}</span> -->
              </li>
            </div>
            <div class="data-title l-h-42 bottom-title2" style="margin-top: 43px;">
              <li style="width:49%;">上期</li>
              <li style="width:49%;">时间</li>
            </div>
            <!-- <div class="bottom-data-lab l-h-42">
              <li class="t-hide">最大值
                <span class="value3"> {{getMax(oldLineArr)}}</span>
              </li>
              <li>{{getMaxTime(oldLineArr)}}</li>
            </div>
            <div class="bottom-data-lab l-h-42">
              <li class="t-hide">最小值
                <span class="value3"> {{getMin(oldLineArr)}}</span>
              </li>
              <li>{{getMinTime(oldLineArr)}}</li>
            </div> -->

            <div class="bottom-data-lab l-h-42">
              <li class="t-hide">最大值<span class="value3" :title="getMin(oldLineArr)"> {{bigNumberTransform(getMax(oldLineArr),5)}}</span>
                <span class="num-unit" style="color: #6766cc;">{{getUnit(getMax(oldLineArr))}}</span></li>
              <li>{{getMaxTime(oldLineArr)}}</li>
            </div>
            <div class="bottom-data-lab l-h-42">
              <li class="t-hide">最小值<span class="value3" :title="getMin(oldLineArr)"> {{bigNumberTransform(getMin(oldLineArr),5)}}</span>
                <span class="num-unit" style="color: #6766cc;">{{getUnit(getMin(oldLineArr))}}</span></li>
              <li>{{getMinTime(oldLineArr)}}</li>
            </div>
            <div class="bottom-data-lab l-h-42">
              <li class="t-hide" style="width: 90%;">平均值
                <span class="value3" :title="getAvg(oldLineArr)"> {{getAvg(oldLineArr)}}</span>
                <!-- <span class="num-unit" style="color: #6766cc;">{{getUnit(getAvg(oldLineArr))}}</span> -->
              </li>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="popup" v-show="popupShow">
      <div class="popup-update">
        <div class="popup-title m-b-22">
          改变分组<i class="el-icon-circle-close close" @click="close"></i>
        </div>
        <div class="popup-lab">
          <p class="lab-title"><i class="star">*</i>所属组织</p>
          <div class="group-name" @click="treeShow = !treeShow">{{orGroupObj.name}}
            <i><img :src="down" id="addOrg2"></i>
            <transition name="el-zoom-in-top">
              <div class="tree-box tree" v-show="treeShow">
                <div class="dashed">
                  <el-tree :data="orTreeData" :props="defaultProps" :default-expand-all="true"
                    @node-click="handleNodeClick">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <!-- <i><img :src="area" class="tree-icon"></i> -->
                      <span>{{ node.label }} </span>
                    </span>
                  </el-tree>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="btn-box">
          <el-button type="primary" @click='update'>确定</el-button>
          <el-button @click="close">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import energyOrganize from "../PublicAssembly/EnergyOrganize.vue"
  import myDatePicker from "../PublicAssembly/MyDatePicket.vue"
  var XLSX = require('xlsx')
  export default {
    data() {
      return {
        timeArr: [],
        dataList: [],
        dateType: 3,
        nullData: require('@/assets/image/index/nullData.png'),
        down: require('@/assets/image/organize/down.png'),
        area: require('@/assets/image/company/jf.png'),
        meter: require('@/assets/image/company/meter.png'),
        chartBg: require('@/assets/image/energy/echarts-bg.jpg'),
        zhen: require('@/assets/image/energy/zhen.png'),
        exportLogUrl: '',
        treeData: [],
        device: {},
        orTreeData: [],
        treeObj: {},
        active: 1,
        checkedArr: [],
        selecting: false,
        EnergyData: {},
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        popupShow: false,
        treeShow: false,
        orGroupObj: {},
        chartSet1: {},
        chartSet2: {},
        chartSet3: {},
        chartSet4: {},
        chartSet5: {},
        chartSet6: {},
        chartSet7: {},
        chartType: 1,
        chartTime: null,
        chartTimeType: 3,
        deviceData: {},
        nowLineArr: [],
        oldLineArr: [],
        nowTime:{},
        oldTime:{}
      }
    },
    components: {
      energyOrganize,
      myDatePicker
    },
    computed: {
      /**
       * 将科学计数法的数字转为字符串
       * 说明：运算精度丢失方法中处理数字的时候，如果出现科学计数法，就会导致结果出错
       * 4.496794759834739e-9  ==> 0.000000004496794759834739
       * 4.496794759834739e+9  ==> 4496794759.834739
       * @param  num
       */
      toNonExponential() {
        return (num) => {
          if (num == null) {
            return num;
          }
          if (typeof num == "number") {
            var m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
            return num.toFixed(Math.max(0, (m[1] || '').length - m[2]));
          } else {
            return num;
          }
        }
      },


      /**
       * 乘法 - js运算精度丢失问题
       * @param arg1  数1
       * @param arg2  数2
       * 0.0023 * 100 ==> 0.22999999999999998
       * {{ 0.0023 | multiply(100) }} ==> 0.23
       */
      floatMultiply() {
        return (arg1, arg2) => {
          arg1 = Number(arg1);
          arg2 = Number(arg2);
          if ((!arg1 && arg1 !== 0) || (!arg2 && arg2 !== 0)) {
            return null;
          }
          arg1 = this.toNonExponential(arg1);
          arg2 = this.toNonExponential(arg2);
          var n1, n2;
          var r1, r2; // 小数位数
          try {
            r1 = arg1.toString().split(".")[1].length;
          } catch (e) {
            r1 = 0;
          }
          try {
            r2 = arg2.toString().split(".")[1].length;
          } catch (e) {
            r2 = 0;
          }
          n1 = Number(arg1.toString().replace(".", ""));
          n2 = Number(arg2.toString().replace(".", ""));
          return n1 * n2 / Math.pow(10, r1 + r2);
        }
      },

      companyId() {
        return this.$store.state.companyId
      },
      getDebtRatio() {
        return (i) => {
          if (this.deviceData.CurrentImbalance != 0 && this.deviceData.CurrentImbalance) {
            // 显示为百分比 *100
            let value = (this.deviceData.CurrentImbalance * 100).toString()
            // 避免当值小于1时 *100后出现小数点的问题  0.211*100=>21.1
            if(this.deviceData.CurrentImbalance<0.1){
              value = '0000' + value
            }else if(this.deviceData.CurrentImbalance<1){
              value = '000' + value
            }else if(this.deviceData.CurrentImbalance<10){
              value = '00' + value
            }
            // console.log(this.deviceData.CurrentImbalance,value)
            if (i == 0 && value.length == 4) {
              return 0
            } else if(value.length == 4){
              return value[i-1]
            }else{
              return value[i]
            }
          } else {
            return 0
          }
        }
      },
      getMax() {
        return (arr) => {
          if (!arr.length) {
            return ""
          }
          let step ,Fixed;
          if (this.chartType == 1) {
            step = this.deviceData.TotalActivePowerstep ||1
          } else if (this.chartType == 2) {
            step = this.deviceData.TotalReactivePowerstep ||1
          } else if (this.chartType == 3) {
            step = this.deviceData.TotalApparentPowerstep ||1
          } else if (this.chartType == 4) {
            step = this.deviceData.VoltageABstep ||1
          } else {
            step = this.deviceData.ElectricityAstep ||1
          }
          if(step.toString().indexOf('.')!=-1){
            Fixed = step.toString().split('.')[1].length
          }else{
            Fixed = 0
          }
          let arr2 = arr.filter((i) =>{return i.value!=null});
          let value = Math.max.apply(Math, arr2.map(item => {
            return item.value
          }))
          return value.toFixed(Fixed)
        }
      },
      getMin() {
        return (arr) => {
          if (!arr.length) {
            return ""
          }
          let step,Fixed;
          if (this.chartType == 1) {
            step = this.deviceData.TotalActivePowerstep ||1
          } else if (this.chartType == 2) {
            step = this.deviceData.TotalReactivePowerstep ||1
          } else if (this.chartType == 3) {
            step = this.deviceData.TotalApparentPowerstep ||1
          } else if (this.chartType == 4) {
            step = this.deviceData.VoltageABstep ||1
          } else {
            step = this.deviceData.ElectricityAstep ||1
          }
          if(step.toString().indexOf('.')!=-1){
            Fixed = step.toString().split('.')[1].length
          }else{
            Fixed = 0
          }
          let arr2 = arr.filter((i) =>{return i.value!=null});
          let value = Math.min.apply(Math, arr2.map(item => {
            return item.value
          }))
          return value.toFixed(Fixed)
        }
      },
      getAvg() {
        return (arr) => {
          if (!arr.length) {
            return ""
          }
          let num = 0
          let step ;
          if (this.chartType == 1) {
            step = this.deviceData.TotalActivePowerstep ||1
          } else if (this.chartType == 2) {
            step = this.deviceData.TotalReactivePowerstep ||1
          } else if (this.chartType == 3) {
            step = this.deviceData.TotalApparentPowerstep ||1
          } else if (this.chartType == 4) {
            step = this.deviceData.VoltageABstep ||1
          } else {
            step = this.deviceData.ElectricityAstep ||1
          }
          let arr2 = arr.filter((i) =>{return i.value!=null});
          arr2.map((obj) => {
            num += Number(obj.value)
          })
          return this.common.fmoney(num / arr2.length,step)
        }
      },
      getMaxTime() {
        return (arr) => {
          if (!arr.length) {
            return ""
          }
          let arr2 = arr.filter((i) =>{return i.value != null});
          let v=arr2[0].value,time=arr2[0].time
          arr2.map(i =>{
            if(i.value>v){
              v = i.value
              time = i.time
            }
          })
          var year = new Date(time).getFullYear()
          var month = new Date(time).getMonth() + 1
          var day = new Date(time).getDate()
          var host = new Date(time).getHours()
          var minu = new Date(time).getMinutes()
          if (month < 10) {
            month = "0" + month
          }
          if (day < 10) {
            day = "0" + day
          }
          if (host < 10) {
            host = "0" + host
          }
          if (minu < 10) {
            minu = "0" + minu
          }
          if (this.chartTimeType == 3) {
            return `${day} ${host}:${minu}`
          } else if (this.chartTimeType == 5) {
            return `${month}-${day} ${host}时`
          } else {
            return `${year}-${month}-${day}`
          }
        }
      },
      getMinTime() {
        return (arr) => {
          if (!arr.length) {
            return ""
          }
          let arr2 = arr.filter((i) =>{return i.value!=null});
          let v=arr2[0].value,time=arr2[0].time
          arr2.map(i =>{
            if(i.value < v){
              v = i.value
              time = i.time
            }
          })
          var year = new Date(time).getFullYear()
          var month = new Date(time).getMonth() + 1
          var day = new Date(time).getDate()
          var host = new Date(time).getHours()
          var minu = new Date(time).getMinutes()
          if (month < 10) {
            month = "0" + month
          }
          if (day < 10) {
            day = "0" + day
          }
          if (host < 10) {
            host = "0" + host
          }
          if (minu < 10) {
            minu = "0" + minu
          }
          if (this.chartTimeType == 3) {
            return `${day} ${host}:${minu}`
          } else if (this.chartTimeType == 5) {
            return `${month}-${day} ${host}时`
          } else {
            return `${year}-${month}-${day}`
          }
          this.$forceUpdate()
        }
      },
      getUnit(){
        return (value)=>{
          if(value==0||!value){ return ''}
          var k = 10000,sizes = ['', '万', '亿', '万亿'],i,unit;
              value = Math.abs(value)
              if(value*10 < k){
                  unit=''
              }else{
                  i = Math.floor(Math.log(value) / Math.log(k));
                  unit = sizes[i];
              }
          return unit;
        }
      },
      getLastDayOfMonth() {
        return (year, month) => {
          //获取本年本月的第一天日期
          var date = new Date(year, month - 1, '01');
          //设置日期
          date.setDate(1);
          //设置月份
          date.setMonth(date.getMonth() + 1);
          //获取本月的最后一天
          var cdate = new Date(date.getTime() - 1000 * 60 * 60 * 24);
          //打印某年某月的最后一天
          //返回结果
          return cdate.getDate();
        }
      }
    },
    created() {
      this.$store.state.energyIndex = '/Energy/ElectricMonitor'
      this.getTree()
      this.getTree2()
    },
    mounted() {
      // this.setGauge1(0)
      // this.setGauge2(23.5)
      // this.setGauge3(41.5)
      // this.setGauge4(9.5)
      // this.setGauge5(59.5)
      // this.setLine()
    },
    methods: {
      clickDevice(obj) {
        if (this.selecting) return
        obj.type = 2
        this.changeNode(obj)
      },
      getDevice() {
        let data = {
          companyId: this.companyId,
          id: this.treeId
        }
        this.get('/Device/get', data).then(res => {
          if (res.success) {
            let propertySet = res.result.propertySet.split(',')
            this.device = res.result
            this.device.propertySet = propertySet
            this.getLine()
            this.getDeviceData()
          } else {
            this.$message({
              type: 'warning',
              message: `获取设备失败：${res.message}`
            })
          }
        })
      },
      getDeviceData() {
        let param = {companyId:this.companyId,code:this.device.code},tsl
        this.get('/ProductFeature/getByDeviceCode',param).then(res=>{
          if(res.success){
            if(res.result==''){
                tsl={properties:[]}
            }else{
                tsl = JSON.parse(res.result)
            }
            let obj = {}
            for(let properties of tsl.properties){  //筛选属性
              if(this.device.propertySet.includes(properties.identifier)){
                obj[properties.identifier + 'step' ] = 1
                obj[properties.identifier + 'unit' ] = ''
                if(properties.dataType.specs&&properties.dataType.specs.step != null){
                  obj[properties.identifier + 'step'] = properties.dataType.specs.step
                }
                if(properties.dataType.specs&&properties.dataType.specs.unit){
                  obj[properties.identifier + 'unit'] = properties.dataType.specs.unit
                }
              }
            }
            let data = {
              companyId: this.companyId,
              deviceId: this.treeObj.id
            }
            this.get('/Device/getPropertyValue', data).then(res => {
              if (res.success) {
                for (let attr of res.result) {
                  // if(attr.value&&attr.value.indexOf('.')!=-1){
                  //   let l = attr.value.slice(attr.value.indexOf('.') +1).length
                  //   attr.value = Number(attr.value).toFixed(l)
                  //   console.log(attr.value,l)
                  // }else{
                  //   attr.value= Number(attr.value)
                  // }
                  obj[attr.code] = attr.value != null ? Number(attr.value) : null
                }
                this.deviceData = obj
                // console.log(this.deviceData)
                this.setGauge5(obj.DebtRatio ? obj.DebtRatio * 100 : 0)
                this.setGauge2(obj.Frequency || 0)
                this.setGauge3(obj.TotalPowerFactor || 0)
                this.setGauge4(obj.VoltageImbalance ? obj.VoltageImbalance * 100 : 0)
                this.setGauge1(obj.CurrentImbalance ? obj.CurrentImbalance * 100 : 0)
              }
            })
          }else{
            this.$message({
              type: 'warning',
              message: `获取关联产品属性失败：${res.message}`
            })
          }
        })

      },
      getLine() {
        if (!this.device.id) return
        let data = {
          companyId: this.companyId,
          deviceCode: this.device.code,
          function: "last",
          timeType: this.chartTimeType,
          time: new Date(this.chartTime + " 0:0:0").getTime()
        }

        if (this.chartType == 1) {
          data.propertyCode = 'TotalActivePower'
        } else if (this.chartType == 2) {
          data.propertyCode = 'TotalReactivePower'
        } else if (this.chartType == 3) {
          data.propertyCode = 'TotalApparentPower'
        } else if (this.chartType == 4) {
          data.propertyCode = 'VoltageAB,VoltageCB,VoltageAC'
          data.function = 'avg'
        } else {
          data.propertyCode = 'ElectricityA,ElectricityB,ElectricityC'
          data.function = 'avg'
        }
        // console.log(data)
        // return
        this.get('/Device/getPropertyHistroy2', data).then(res => {
          if (res.success) {
            this.getLine2()
            this.nowLineArr = res.result
          } else {
            this.$message({
              type: 'warning',
              message: `获取图表数据失败：${res.message}`
            })
          }
        })
      },
      getLine2() {
        if (!this.device.id) return
        let data = {
          companyId: this.companyId,
          deviceCode: this.device.code,
          function: "last",
          timeType: this.chartTimeType,
        }
        // 获取昨天，上个月，去年的数据
        var year = new Date(this.chartTime + " 0:0:0").getFullYear()
        var month = new Date(this.chartTime + " 0:0:0").getMonth()
        var day = new Date(this.chartTime + " 0:0:0").getDate()
        if (this.chartTimeType == 3) {
          var newTime = new Date(this.chartTime + " 0:0:0").setDate(day - 1)
          year = new Date(newTime).getFullYear()
          month = new Date(newTime).getMonth() + 1
          day = new Date(newTime).getDate()
          data.time = new Date(year + '-' + month + "-" + day + " 0:0:0").getTime()
        } else if (this.chartTimeType == 5) {
          var newTime = new Date(this.chartTime + " 0:0:0").setMonth(month - 1)
          year = new Date(newTime).getFullYear()
          month = new Date(newTime).getMonth() + 1
          data.time = new Date(year + '-' + month + "-01 0:0:0").getTime()
        } else if (this.chartTimeType == 7) {
          year = new Date(this.chartTime + " 0:0:0").setFullYear(year - 1)
          var lastYear = new Date(year).getFullYear()
          data.time = new Date(lastYear + "-01-01 0:0:0").getTime()
        }
        if (this.chartType == 1) {
          data.propertyCode = 'TotalActivePower'
        } else if (this.chartType == 2) {
          data.propertyCode = 'TotalReactivePower'
        } else if (this.chartType == 3) {
          data.propertyCode = 'TotalApparentPower'
        } else if (this.chartType == 4) {
          data.propertyCode = 'VoltageAB,VoltageCB,VoltageAC'
          data.function = 'avg'
        } else {
          data.propertyCode = 'ElectricityA,ElectricityB,ElectricityC'
          data.function = 'avg'
        }
        // console.log(data)
        // return
        this.get('/Device/getPropertyHistroy2', data).then(res => {
          if (res.success) {
            this.oldLineArr = res.result
            this.setLine()
          } else {
            // this.$message({
            //   type: 'warning',
            //   message: `获取图表数据失败：${res.message}`
            // })
          }
        })
      },
      setChartType(i) {
        this.chartType = i
        this.getLine()
      },
      setLine() {
        let value = this.nowLineArr
        let value2 = this.oldLineArr
        let newArry = value.sort(function(a, b) {
          return a.time - b.time;
        });
        let self = this
        let unit = this.deviceData.ElectricityAunit||this.deviceData.ElectricityBunit||this.deviceData.ElectricityCunit
        let oldArry = value2.sort(function(a, b) {
          return a.time - b.time;
        });
        let nowDataArr = []
        for (let item of newArry) {
          let arr = []
          if (item.time) {
            if (this.chartTimeType == 5) {
              var month = new Date(item.time).getMonth()
              var time = new Date(item.time).setMonth(4)
              arr.push(this.changeTime(time))
              arr.push(item.value == null ? '-' : item.value)
            } else {
              arr.push(this.changeTime(item.time))
              arr.push(item.value == null ? '-' : item.value)
            }
          }
          nowDataArr.push(arr)
        }
        let oldDataArr = []
        for (let item of oldArry) {
          let arr = [],
            time
          if (item.time) {
            if (this.chartTimeType == 3) {
              var day = new Date(item.time).getDate()
              time = new Date(item.time).setDate(day + 1)
            } else if (this.chartTimeType == 5) {
              var month = new Date(item.time).getMonth()
              time = new Date(item.time).setMonth(4)
              var year = new Date(self.chartTime).getFullYear()
              time = new Date(time).setFullYear(year)
            } else {
              var year = new Date(item.time).getFullYear()
              time = new Date(item.time).setFullYear(year + 1)
            }
            arr.push(this.changeTime(time))
            arr.push(item.value == null ? '-' : item.value)
          }
          oldDataArr.push(arr)
        }
        let name = "电流",step= self.deviceData.ElectricityAstep ||1
        if (self.chartType == 1) {
          name = '有功功率'
          step = self.deviceData.TotalActivePowerstep ||1
          unit = self.deviceData.TotalActivePowerunit
        } else if (self.chartType == 2) {
          name = '无功功率'
          step = self.deviceData.TotalReactivePowerstep ||1
          unit = self.deviceData.TotalReactivePowerunit
        } else if (self.chartType == 3) {
          name = '视在功率'
          step = self.deviceData.TotalApparentPowerstep ||1
          unit = self.deviceData.TotalApparentPowerunit
        } else if (self.chartType == 4) {
          name = '电压'
          step = self.deviceData.VoltageABstep ||1
          unit = self.deviceData.VoltageABunit||self.deviceData.VoltageACunit||self.deviceData.VoltageCBunit
        }
        // let newTime = nowDataArr[0][0]
        // let newMinute = new Date(newTime).getMinutes()
        // let newTime2 = new Date(newTime).setMinutes(newMinute-1)
        // let newarr =[this.changeTime(newTime2),'--']
        // nowDataArr.unshift(newarr)
        // let oldTime = oldDataArr[0][0]
        // let oldMinute = new Date(oldTime).getMinutes()
        // let oldTime2 = new Date(oldTime).setMinutes(oldMinute)
        // let oldarr =[this.changeTime(oldTime2),'--']
        // oldDataArr.unshift(oldarr)
        const data = {
          nowDataArr,
          oldDataArr
        };
        // console.log(nowDataArr,oldDataArr)
        let endDay
        if (this.chartTimeType == 5) {
          endDay = this.getLastDayOfMonth(new Date(this.chartTime).getFullYear(), new Date(this.chartTime).getMonth() +
            1)
        }
        let option = {
          tooltip: {
            trigger: 'axis',
            backgroundColor: '#fff',
            borderWidth: '0',
            padding: 10,
            formatter: function(params) {
              if (!params[0]) {
                return '';
              }
              let time = params[0].data[0]
              if (self.chartTimeType == 5) {
                var day = new Date(time).getDate()
                if (day > endDay) {
                  return ''
                }
                var year = new Date(self.chartTime).getFullYear()
                var month = new Date(self.chartTime).getMonth() + 1
                var h = new Date(time).getHours()
                month < 10 ? month = '0' + month : month = month
                day < 10 ? day = '0' + day : day = day
                h < 10 ? h = '0' + h : h = h
                time = `${year}-${month}-${day} ${h}时`
              }
              if (self.chartTimeType == 7) {
                var day = new Date(time).getDate()
                if (day > endDay) {
                  return ''
                }
                var year = new Date(self.chartTime).getFullYear()
                var month = new Date(self.chartTime).getMonth() + 1
                month < 10 ? month = '0' + month : month = month
                day < 10 ? day = '0' + day : day = day
                time = `${year}-${month}-${day}`
              }
              if (self.chartTimeType == 3) {
                var day = new Date(time).getDate()
                if (day > endDay) {
                  return ''
                }
                var year = new Date(self.chartTime).getFullYear()
                var month = new Date(self.chartTime).getMonth() + 1
                var h = new Date(time).getHours()
                var m = new Date(time).getMinutes()
                month < 10 ? month = '0' + month : month = month
                day < 10 ? day = '0' + day : day = day
                h < 10 ? h = '0' + h : h = h
                m < 10 ? m = '0' + m : m = m
                time = `${year}-${month}-${day} ${h}:${m}`
              }
              let html = `<p style="font-size:14x;color:#292929;font-weight:400;">${time}</p>`;
              for (let item of params) {
                html +=
                  `<p style="text-align:left;"><span style="display:inline-block;margin-right: 4px;border-radius: 10px;width: 10px; height: 10px;background-color: ${item.color};"></span><span style="font-size:14px;color:#292929;font-weight:400;">${item.seriesName}：</span><span style="font-size:16px;color:${item.color};font-family: AgencyFB;font-weight:bold;">${item.data[1]=='-'?'--':self.common.fmoney(item.data[1],step)}</span>`
                if (item.data[1] != '-') {
                  html += `<span style="font-size:12px;margin-left:2px;">${unit}</span>`
                }
                html +=`</p>`
              }
              return html;
            }
          },
          grid: {
            left: '80',
            right: '70',
            bottom: '30',
            top: '55'
          },
          legend: {
            data: ['本期' + name, '上期' + name],
            x:'right',
            y:'top',
            itemWidth:10,
            itemHeight:10,
            icon: 'circle',
            padding:[20,80,0,0]
          },
          yAxis: [{
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dotted',
                  color: 'rgba(155, 155, 155, 0.5)'
                }
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                color: '#5A6872',
                fontSize: 11
              },
              axisTick: {
                show: false
              },
              type: 'value'
            },
            {
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dotted',
                  color: 'rgba(155, 155, 155, 0.5)'
                }
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                color: '#5A6872',
                fontSize: 11
              },
              axisTick: {
                show: false
              },
              type: 'value'
            }
          ],
          xAxis: [{
              type: 'time', // x轴为 时间轴
              splitLine: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  width: 0
                }
              },
              axisLabel: {
                color: '#5A6872',
                fontSize: 11,
                formatter: function(value) {
                  if (self.chartTimeType == 3) {
                    let h = new Date(value).getHours(),
                      m = new Date(value).getMinutes()
                    if (h < 10) {
                      h = '0' + h
                    }
                    if (m < 10) {
                      m = '0' + m
                    }
                    return `${h}:${m}`
                  } else if (self.chartTimeType == 5) {
                    let d = new Date(value).getDate()
                    if (d < 10) {
                      d = '0' + d
                    }
                    return `${d}日`
                  } else {
                    let m = new Date(value).getMonth() + 1
                    if (m < 10) {
                      m = '0' + m
                    }
                    return `${m}月`
                  }
                }
              },
              axisTick: {
                show: false
              },
              boundaryGap: false,
              splitNumber: 12,
              data: data[data.nowDataArr.length > data.oldDataArr.length ? 'nowDataArr' : 'oldDataArr'].map(
                function(item) {
                  if (self.chartTimeType == 3) {
                    let h = new Date(item[0]).getHours(),
                      m = new Date(item[0]).getMinutes()
                    if (h < 10) {
                      h = '0' + h
                    }
                    if (m < 10) {
                      m = '0' + m
                    }
                    return `${h}:${m}`
                  } else if (self.chartTimeType == 5) {
                    let d = new Date(item[0]).getDate()
                    if (d < 10) {
                      d = '0' + d
                    }
                    return `${d}日`
                  } else {
                    let m = new Date(item[0]).getMonth() + 1
                    let d = new Date(item[0]).getDate()
                    if (d < 10) {
                      d = '0' + d
                    }
                    if (m < 10) {
                      m = '0' + m
                    }
                    return `${m}月${d}日`
                  }
                })
            },
            // {
            //   type: 'time', // x轴为 时间轴
            //   splitLine: { show: false },
            //   axisLine: {
            //     lineStyle: { width: 0 }
            //   },
            //   axisLabel: {
            //     color: '#5A6872',
            //     fontSize: 11,
            //     formatter:function(value) {
            //       if(self.chartTimeType==3){
            //         let h = new Date(value).getHours(),m =  new Date(value).getMinutes()
            //         if(h<10){ h = '0'+h }
            //         if(m<10){ m = '0'+m }
            //         return `${h}:${m}`
            //       }else if(self.chartTimeType==5){
            //         let d = new Date(value).getDate()
            //         if(d<10){ d = '0'+d }
            //         return `${d}日`
            //       }else{
            //         let m = new Date(value).getMonth()+1
            //         if(m<10){ m = '0'+m }
            //         return `${m}月`
            //       }
            //     }
            //   },
            //   axisTick: { show: false },
            //   boundaryGap: false,
            //   splitNumber: 12,
            //   data: data['nowDataArr'].map(function(item) {
            //     if(self.chartTimeType==3){
            //       let h = new Date(item[0]).getHours(),m =  new Date(item[0]).getMinutes()
            //       if(h<10){ h = '0'+h }
            //       if(m<10){ m = '0'+m }
            //       return `${h}:${m}`
            //     }else if(self.chartTimeType==5){
            //       let d =  new Date(item[0]).getDate()
            //       if(d<10){ d = '0'+d }
            //       return `${d}日`
            //     }else{
            //       let m = new Date(item[0]).getMonth()+1
            //       let d =  new Date(item[0]).getDate()
            //       if(d<10){ d = '0'+d }
            //       if(m<10){ m = '0'+m }
            //       return `${m}月${d}日`
            //     }
            //   })
            // }
          ],
          // legend: { data: titles },
          color: ['#01A6AC', '#6766cc'],
          series: [{
              name: '本期' + name,
              type: 'line',
              symbol: 'none',
              smooth: true,
              markPoint: {
                label: {
                  normal: {
                    show: true,
                    backgroundColor: '#fff',
                    position: 'top',
                    color: '#01A6AC',
                    borderRadius: 2,
                    borderColor: '#5087E4',
                    borderWidth: 1,
                    padding: 8,
                    formatter: function(data){
                      let value = data.value
                      if(value!='-'){
                        value = self.common.fmoney(value,step)
                      }
                      return `${data.name}：${value}`
                    }
                  }
                },
                symbol: 'circle',
                itemStyle: {
                  normal: {
                    borderColor: 'rgba(65,214,195,0.3)',
                    borderWidth: 15
                  }
                },
                symbolSize: 7,
                data: [{
                    type: 'max',
                    name: '最大值'
                  },
                  {
                    type: 'min',
                    name: '最小值'
                  }
                ]
              },
              lineStyle: {
                normal: {
                  color: '#01A6AC',
                  width: 2
                }
              },
              data: data['nowDataArr']
            },

            {
              name: '上期' + name,
              type: 'line',
              symbol: 'none',
              smooth: true,
              markPoint: {
                label: {
                  normal: {
                    show: true,
                    backgroundColor: '#fff',
                    position: 'top',
                    color: '#6766CC',
                    borderRadius: 2,
                    borderColor: '#5087E4',
                    borderWidth: 1,
                    padding: 8,
                    formatter: function(data){
                      let value = data.value
                      if(value!='-'){
                        value = self.common.fmoney(value,step)
                      }
                      return `${data.name}：${value}`
                    }
                  }
                },
                symbol: 'circle',
                itemStyle: {
                  normal: {
                    borderColor: 'rgba(65,214,195,0.3)',
                    borderWidth: 15
                  }
                },
                symbolSize: 7,
                data: [{
                    type: 'max',
                    name: '最大值'
                  },
                  {
                    type: 'min',
                    name: '最小值'
                  }
                ]
              },
              lineStyle: {
                normal: {
                  color: '#6766CC',
                  width: 2
                }
              },
              data: data['oldDataArr']
            }
          ]
        };
        let dom = this.$refs.line
        let Dom = this.$echarts.getInstanceByDom(document.getElementById("line"))
        if (Dom == null) {
          this.chartSet7 = this.$echarts.init(dom, '', {
            width: dom.offsetWidth, //设置宽高
            height: dom.offsetHeight - 20
          })
        }
        this.chartSet7.setOption(option, true)
      },
      setGauge5(value) {
        const gaugeData = [{
          value: value / 100,
          name: 'Perfect',
          title: {
            show: false,
            offsetCenter: ['0%', '-40%']
          },
          detail: {
            show: false,
            fontSize: 26,
            fontFamily: "AgencyFB",
            valueAnimation: false,
            offsetCenter: ['0%', '10%'],
          },
          itemStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                  offset: 0,
                  color: '#66FF99' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: '#00CC00' // 100% 处的颜色
                }
              ],
              global: false // 缺省为 false
            }
          }
        }];
        let option = {
          series: [{
            type: 'gauge',
            startAngle: 90,
            endAngle: -270, // 参数:number, string。 仪表盘半径,默认 75% ，可以是相对于容器高宽中较小的一项的一半的百分比，也可以是绝对的数值。
            center: ['50%', '55%'],
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: false,
              clip: false,
              itemStyle: {}
            },
            axisLine: {
              lineStyle: {
                color: [
                  [1, '#fff']
                ],
                width: 4,
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 6
              }
            },
            splitLine: {
              show: false,
              distance: -10,
              length: 5,
              lineStyle: {
                type: 'solid',
                color: '#fff'
              }
            },
            axisTick: {
              length: 5,
              distance: 5,
              splitNumber: 3,
              lineStyle: {
                width: 2,
                color: '#eee'
              }
            },
            axisLabel: {
              show: false
            },
            data: gaugeData,
            title: {
              fontSize: 14
            },
            detail: {
              fontSize: 25,
              formatter: '{value}'
            }
          }]
        };
        let dom = this.$refs.gauge5
        let Dom = this.$echarts.getInstanceByDom(document.getElementById("gauge5"))
        if (Dom == null) {
          this.chartSet6 = this.$echarts.init(dom, '', {
            width: 160, //设置宽高
            height: 138
          })
        }
        this.chartSet6.setOption(option, true)
      },
      setGauge4(value) {
        const gaugeData = [{
          value: value / 100,
          name: 'Perfect',
          title: {
            show: false,
            offsetCenter: ['0%', '-40%']
          },
          detail: {
            show: false,
            fontSize: 26,
            fontFamily: "AgencyFB",
            valueAnimation: false,
            offsetCenter: ['0%', '10%'],
          },
          itemStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                  offset: 0,
                  color: '#66FFCC' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: '#00FFFF' // 100% 处的颜色
                }
              ],
              global: false // 缺省为 false
            }
          }
        }];
        let option = {
          series: [{
            type: 'gauge',
            startAngle: 90,
            endAngle: -270, // 参数:number, string。 仪表盘半径,默认 75% ，可以是相对于容器高宽中较小的一项的一半的百分比，也可以是绝对的数值。
            center: ['50%', '55%'],
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: false,
              clip: false,
              itemStyle: {}
            },
            axisLine: {
              lineStyle: {
                color: [
                  [1, '#fff']
                ],
                width: 4,
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 6
              }
            },
            splitLine: {
              show: false,
              distance: -10,
              length: 5,
              lineStyle: {
                type: 'solid',
                color: '#fff'
              }
            },
            axisTick: {
              length: 5,
              distance: 5,
              splitNumber: 3,
              lineStyle: {
                width: 2,
                color: '#eee'
              }
            },
            axisLabel: {
              show: false
            },
            data: gaugeData,
            title: {
              fontSize: 14
            },
            detail: {
              fontSize: 25,
              formatter: '{value}'
            }
          }]
        };
        let dom = this.$refs.gauge4
        let Dom = this.$echarts.getInstanceByDom(document.getElementById("gauge4"))
        if (Dom == null) {
          this.chartSet5 = this.$echarts.init(dom, '', {
            width: 160, //设置宽高
            height: 138
          })
        }
        this.chartSet5.setOption(option, true)
      },

      setGauge3(value) {
        const gaugeData = [{
          value: value * 100,
          name: 'Perfect',
          title: {
            show: false,
            offsetCenter: ['0%', '-40%']
          },
          detail: {
            show: false,
            fontSize: 26,
            fontFamily: "AgencyFB",
            valueAnimation: false,
            offsetCenter: ['0%', '10%'],
          },
          itemStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                  offset: 0,
                  color: '#FFD800' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: '#FF9900' // 100% 处的颜色
                }
              ],
              global: false // 缺省为 false
            }
          }
        }];
        let option = {
          series: [{
            type: 'gauge',
            startAngle: 90,
            endAngle: -270, // 参数:number, string。 仪表盘半径,默认 75% ，可以是相对于容器高宽中较小的一项的一半的百分比，也可以是绝对的数值。
            center: ['50%', '55%'],
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: false,
              clip: false,
              itemStyle: {}
            },
            axisLine: {
              lineStyle: {
                color: [
                  [1, '#fff']
                ],
                width: 4,
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 6
              }
            },
            splitLine: {
              show: false,
              distance: -10,
              length: 5,
              lineStyle: {
                type: 'solid',
                color: '#fff'
              }
            },
            axisTick: {
              length: 5,
              distance: 5,
              splitNumber: 3,
              lineStyle: {
                width: 2,
                color: '#eee'
              }
            },
            axisLabel: {
              show: false
            },
            data: gaugeData,
            title: {
              fontSize: 14
            },
            detail: {
              fontSize: 25,
              formatter: '{value * 100}'
            }
          }]
        };
        let dom = this.$refs.gauge3
        let Dom = this.$echarts.getInstanceByDom(document.getElementById("gauge3"))
        if (Dom == null) {
          this.chartSet4 = this.$echarts.init(dom, '', {
            width: 160, //设置宽高
            height: 138
          })
        }
        this.chartSet4.setOption(option, true)
      },
      setGauge2(value) {
        if (!value) {
          value = 0
        }
        const gaugeData = [{
          value: value,
          name: 'Perfect',
          title: {
            show: false,
            offsetCenter: ['0%', '-40%']
          },
          detail: {
            show: false,
            fontSize: 26,
            valueAnimation: false,
            offsetCenter: ['0%', '10%'],
            // formatter:function (value) {
            //   let html = `<span>${value} <span style="font-size:12px">Hz</span></span>`
            //   return html;
            // }
          },
          itemStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                  offset: 0,
                  color: '#66ccff' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: '#3399FF' // 100% 处的颜色
                }
              ],
              global: false // 缺省为 false
            }
          }
        }];
        let option = {
          series: [{
            type: 'gauge',
            startAngle: 90,
            endAngle: -270, // 参数:number, string。 仪表盘半径,默认 75% ，可以是相对于容器高宽中较小的一项的一半的百分比，也可以是绝对的数值。
            center: ['50%', '55%'],
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: false,
              clip: false,
              itemStyle: {}
            },
            axisLine: {
              lineStyle: {
                color: [
                  [1, '#fff']
                ],
                width: 4,
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 6
              }
            },
            splitLine: {
              show: false,
              distance: -10,
              length: 5,
              lineStyle: {
                type: 'solid',
                color: '#fff'
              }
            },
            axisTick: {
              length: 5,
              distance: 5,
              splitNumber: 3,
              lineStyle: {
                width: 2,
                color: '#eee'
              }
            },
            axisLabel: {
              show: false
            },
            data: gaugeData,
            title: {
              fontSize: 14
            },
            detail: {
              fontSize: 25,
              color: '#3399ff',
              formatter: '{value}'
            }
          }]
        };
        let dom = this.$refs.gauge2
        let Dom = this.$echarts.getInstanceByDom(document.getElementById("gauge2"))
        if (Dom == null) {
          this.chartSet3 = this.$echarts.init(dom, '', {
            width: 160, //设置宽高
            height: 138
          })
        }
        this.chartSet3.setOption(option, true)
      },
      setGauge1(value) {
        let img = "image://" + this.zhen
        let option = {
          graphic: {
            elements: [{
              type: "image",
              right: "79%", // 根据父元素进行定位 （居中）
              bottom: '88%',
              style: {
                image: this.chartBg,
              }
            }]
          },
          series: [{
            type: 'gauge',
            axisLine: {
              lineStyle: {
                width: 5,
                color: [
                  [0.4, '#81a0df'],
                  [0.7, '#5cbe5c'],
                  [1, '#ce6262']
                ]
              }
            },
            pointer: {
              icon: img,
              width: 26,
              length: 111,
              offsetCenter: [0, 13],
            },
            splitNumber: 5,
            axisTick: {
              distance: -20,
              length: 5,
              lineStyle: {
                color: '#ececec',
                width: 2
              }
            },
            splitLine: {
              distance: -25,
              length: 12,
              lineStyle: {
                color: '#ececec',
                width: 3
              }
            },
            axisLabel: {
              color: '#0c6b8b',
              distance: -30,
              fontSize: 14
            },
            detail: {
              show: true,
              valueAnimation: true,
              fontWeight: 500,
              offsetCenter: [0, '80%'],
              formatter: '电流不平衡度(%)',
              color: '#4E596B',
              fontSize: 16
            },
            data: [{
              value: value / 100
            }]
          }]
        };
        let dom = this.$refs.gauge1
        let Dom = this.$echarts.getInstanceByDom(document.getElementById("gauge1"))
        if (Dom == null) {
          this.chartSet2 = this.$echarts.init(dom, '', {
            width: 408, //设置宽高
            height: 313
          })
        }
        this.chartSet2.setOption(option, true)
      },
      // 改变分组
      update() {
        let data = {
          companyId: this.companyId,
          id: this.orGroupObj.id,
          deviceList: this.checkedArr.toString()
        }
        this.post('/EnergyGroup/setEnergyGroup', data).then(res => {
          if (res.success) {
            this.popupShow = false
            this.treeShow = false
            this.getTree(true)
          } else {
            this.$message({
              type: 'warning',
              message: `改变分组失败：${res.message}`
            })
          }
        })
      },
      //
      close() {
        this.popupShow = false
        this.treeShow = false
      },
      // 点击所属组树组件
      handleNodeClick(node) {
        this.orGroupObj = node
        this.treeShow = false
      },
      // 点击修改组织弹窗
      clickSetGroup() {
        this.orGroupObj = this.clone(this.treeObj)
        this.popupShow = true
      },
      // 选择设备
      changeDevice(code) {
        if (!this.checkedArr.includes(code)) {
          this.checkedArr.push(code)
        } else {
          for (let i in this.checkedArr) {
            if (this.checkedArr[i] == code) {
              this.checkedArr.splice(i, 1)
            }
          }
        }
      },
      // 获取能源数据
      getEnergyData() {
        let data = {
          companyId: this.companyId,
          id: this.treeObj.id
        }
        this.get('/ElectricSummary/getPropertyValue', data).then((res) => {
          if (res.success) {
            this.EnergyData = res.result
          } else {
            this.$message({
              type: 'warning',
              message: `获取电表汇总数据失败：${res.message}`
            })
          }
        })
      },
      // 获取柱状图数据
      getCategoryData() {
        let data = {
          companyId: this.companyId,
          groupId: this.treeObj.id,
          groupType: 1,
          timeType: this.dateType,
          time: new Date(this.timeArr[0] + " 0:0:0").getTime()
        }
        this.get('/EnergyReport/getMeterReport', data).then((res) => {
          if (res.success) {
            let arr = []
            for (let item of res.result) {
              let arr2 = []
              arr2.push(item.name)
              arr2.push(item.value == 'null' ? '-' : item.value)
              arr2.push(item.code)
              arr.push(arr2)
            }
            this.setCategory(arr)
          } else {
            this.$message({
              type: 'warning',
              message: `获取电表汇总数据失败：${res.message}`
            })
          }
        })
      },
      // setChart
      setCategory(data) {
        let self = this
        let option = {
          tooltip: {
            trigger: 'axis',
            backgroundColor: '#fff',
            borderWidth: '0',
            padding: 10,
            formatter: function(params) {
              if (!params[0]) {
                return '';
              }
              let name = params[0].data[0]
              let html = `<span style="font-size:14x;color:#292929;font-weight:400;">${name}</span>`;
              for (let item of params) {
                html +=
                  `<br><span style="display:inline-block;margin-right: 4px;border-radius: 10px;width: 10px; height: 10px;background-color: ${item.color};"></span><span style="font-size:14px;color:#292929;font-weight:400;">${item.seriesName}：</span><span style="font-size:16px;color:${item.color};font-family: AgencyFB;font-weight:bold;">${item.data[1]==null?'--':self.fmoney(item.data[1])}</span>`
                if (item.data[1] != null) {
                  html += '<span style="font-size:12px;margin-left:2px;">kW·h</span>'
                } else {
                  html += '<br>'
                }
              }
              return html;
            }
          },
          dataset: [{
              dimensions: ['name', 'value', 'code'],
              source: data
            },
            {
              transform: {
                type: 'sort',
                config: {
                  dimension: 'value',
                  order: 'desc'
                }
              }
            }
          ],
          grid: {
            left: '100',
            right: '10',
            bottom: '160',
            top: '30'
          },
          xAxis: {
            type: 'category',
            axisLabel: {
              interval: 0,
              rotate:  0,
              formatter: function (value) {
                //x轴的文字改为竖版显示
                var name = data.filter(i=>i[2] == value)[0][0]
                if(data.length>=15){
                  var str = name.split("");
                  return str.join("\n");
                // return '{a|' + value + '}';
                }else{
                  return name
                }
              },
            }
          },
          yAxis: {},
          series: {
            name: "用电量",
            type: 'bar',
            label: {
              show: true,
              position: "top",
            },
            color: "#ff7b7b",
            barWidth: 30,
            encode: {
              x: 'code',
              y: 'value'
            },
            datasetIndex: 1,
            label: {
              show: false,
              position: 'top',
              formatter: function(a) {
                if (a.data[1] != null) {
                  return self.fmoney(a.data[1])
                }
                return a.data[1]
              }
            }
          }
          // grid: {
          //   bottom: 60
          // },
          // dataZoom: {
          //   show: true,
          //   realtime: true,
          //   type: "slider",
          //   height: 15,
          //   start: 0,
          //   end: 60
          // }
        };
        let dom = this.$refs.Category
        let Dom = this.$echarts.getInstanceByDom(document.getElementById("Category"))
        if (Dom == null) {
          this.chartSet1 = this.$echarts.init(dom, '', {
            width: data.length >= 30 ? (data.length * 40) + 100 : dom.offsetWidth, //设置宽高
            height: dom.offsetHeight
          })
        }
        setTimeout(() => {
          this.chartSet1.setOption(option, true)
        }, 200)
      },
      // 获取组织树
      getTree(getlist) {
        let data = {
          companyId: this.$store.state.companyId,
          type: 1
        }
        this.get('/EnergyGroup/getTreeWithDevice', data).then(res => {
          if (res.success) {
            this.treeData = res.result
          } else {
            this.$message({
              type: 'warning',
              message: getlist ? '更新' : '获取' + `组织树数据失败：${res.message}`
            })
          }
        }).then(() => {
          if (getlist) {
            this.getList()
          }
        })

      },
      getTree2() {
        let data = {
          companyId: this.$store.state.companyId,
          type: 1
        }
        this.get('/EnergyGroup/getTree', data).then(res => {
          if (res.success) {
            this.orTreeData = res.result
          } else {
            this.$message({
              type: 'warning',
              message: `获取组织树数据失败：${res.message}`
            })
          }
        })
      },
      // 更新树节点
      changeNode(data) {
        this.treeId = data.id
        this.treeObj = data
        if (data.type == 1) {
          this.getList()
          if (this.active == 2) {
            this.getEnergyData()
            this.getCategoryData()
          }
        } else {
          this.getDevice()
        }
      },

      setTree(data) {
        this.treeData = data
        this.$forceUpdate()
      },
      // 获取列表
      getList() {
        if (!this.treeId && this.treeId != 0) {
          return
        }
        let data = {
          companyId: this.$store.state.companyId,
          id: this.treeId,
          type: 1
        }
        this.get('/EnergyGroup/getDeviceList', data).then(res => {
          if (res.success) {
            this.dataList = res.result||[]
          } else {
            this.$message({
              type: 'warning',
              message: `获取数据失败：${res.message}`
            })
          }
        })

      },
      changeTime2(v, type) {
        if (v) {
          this.timeArr = v
          this.dateType = type
          if(this.active==2){
            this.getEnergyData()
            this.getCategoryData()
          }
        }
      },
      changeTime3(v, type) {
        if (v) {
          this.chartTime = v
          this.chartTimeType = type
          // console.log(v)
          this.getLine()
        }
      },
    },
    watch: {
      selecting() {
        if (!this.selecting) {
          this.checkedArr = []
        }
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      },
      active() {
        if (this.active == 2) {
          setTimeout(() => {
            this.getEnergyData()
            this.getCategoryData()
          }, 100)
        }else{
          this.getList()
        }
      }
    }
  }
</script>

<style scoped>
  .legend {
    font-size: 12px;
    color: #2d2d2d;
    text-align: right;
    padding-right: 60px;
    box-sizing: border-box;
  }

  .legend>span {
    margin-right: 10px;
    display: inline-block;
    width: 10px;
    height: 10px;
    background: #ff7b7b;
    margin-right: 10px;
  }

  .bottom-title2>li:first-child {
    margin-left: 0 !important;
  }

  .bottom-title2,
  .bottom-data-lab {
    padding-left: 17px;
    box-sizing: border-box;
  }

  .bottom-data-lab {
    border-bottom: 1px dashed #EDEDED;
  }

  .bottom-data-lab li {
    width: 45%;
    display: inline-block;
    color: #232674;
    font-size: 14px;
  }

  .bottom-data-lab li.t-hide {
    float: left;
    width: 52%;
  }

  .l-h-42 {
    line-height: 42px;
  }

  .bottom-chart {
    width: 100%;
    height: 340px;
  }

  .bottom-left {
    width: 78%;
    height: 100%;
    margin-left: 10px;
  }

  .bottom-right {
    width: 21%;
    height: 100%;
    text-align: left;
  }

  .data-lab {
    height: 30px;
    border-bottom: 1px dashed #EDEDED;
  }

  .value {
    font-size: 16px;
    font-family: agencyr;
  }

  .value2 {
    font-size: 18px;
    color: #01A6AC;
    font-family: agencyr;
  }

  .value3 {
    font-size: 18px;
    color: #6766CC;
    font-family: agencyr;
  }

  .unit {
    font-size: 12px;
  }

  .blue {
    color: #3399FF;
  }

  .yellow {
    color: #F7AF13;
  }

  .red {
    color: #FF0066;
  }

  .green {
    color: #53BA53;
  }

  .black {
    color: #232674;
  }

  .data-lab li {
    display: inline-block;
    line-height: 38px;
    position: relative;
    top: -5px;
    font-weight: 400;
    color: #151515;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .w-160 {
    width: 20%;
  }

  .w-145 {
    width: 16%;
  }

  .w-200 {
    width: 25%;
  }

  .data-title>li {
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    color: #4E596B;
  }

  .data-title>li:first-child,
  .data-lab>li:first-child {
    margin-left: 38px;
  }

  .bottom-data {
    text-align: left;
    width: 94%;
    margin: 0 auto;
    line-height: 42px;
  }

  .data-title {
    height: 42px;
    background: #EEEEEE;
    opacity: 0.7;
  }

  .data-span {
    position: absolute;
    top: 95px;
    left: 50%;
    display: inline-block;
    text-align: center;
    font-size: 26px;
    width: 88px;
    margin-left: -44px;
    font-family: AgencyFB;
  }

  .data {
    -webkit-line-clamp: 2;
    background-image: -webkit-linear-gradient(top, #66CCFF, #3399FF);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .gv {
    background-image: -webkit-linear-gradient(top, #FFD800, #ff9900);
  }

  .dy {
    background-image: -webkit-linear-gradient(top, #66FFCC, #00FFFF);
  }

  .dl {
    background-image: -webkit-linear-gradient(top, #66FF99, #00CC00);
  }

  .data-box {
    font-size: 32px;
    font-weight: bold;
  }

  .data-box span {
    width: 30px;
    height: 50px;
    margin: 0 4px;
    display: inline-block;
    background: url(../../assets/image/energy/data.png) no-repeat;
    background-size: cover;
  }

  .echars-box {
    padding-top: 20px;
    box-sizing: border-box;
    width: 408px;
    height: 313px;
  }

  .device-bottom {
    width: 95.5%;
    height: 44%;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(163, 166, 173, 0.06);
    border-radius: 8px;
    padding-top: 20px;
  }

  .left-box {
    width: 30.5%;
    height: 97%;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(163, 166, 173, 0.06);
    border-radius: 8px;
    margin: 0 20px 20px 0;
  }

  .right-box {
    width: 63.5%;
    height: 97%;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(163, 166, 173, 0.06);
    border-radius: 8px;
  }

  .top-charts {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .top-charts>div {
    width: 160px;
    height: 170px;
    font-size: 18px;
    font-weight: 400;
    color: #4E596B;
    text-align: center;
    position: relative;
  }

  .top-charts>div p {
    position: relative;
    top: 15px;
  }

  .tree-box {
    position: absolute;
    left: -1px;
    top: 32px;
    border: 1px solid #e5e5e5;
    max-height: 315px;
    overflow: auto;
    width: 100%;
    border-radius: 5px;
    z-index: 99;
    background: #fff;
  }

  .group-name {
    width: 100%;
    height: 34px;
    line-height: 34px;
    border-radius: 5px;
    border: 1px solid #e5e5e5;
    padding: 0 10px;
    position: relative;
    box-sizing: border-box;
  }

  .group-name>i {
    float: right;
  }

  .group-name>i>img {
    width: 22px;
    margin-top: 6px;
  }

  .m-b-22 {
    margin-bottom: 22px !important;
  }

  .popup {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, .4);
    z-index: 999;
  }

  .popup-update {
    text-align: left;
    position: fixed;
    top: 30%;
    left: 50%;
    padding: 0 28px;
    box-sizing: border-box;
    margin-left: -230px;
    width: 508px;
    background-color: #fff;
    z-index: 9999;
    padding-bottom: 48px;
  }

  .popup-title {
    font-size: 16px;
    line-height: 64px;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 22px;
    text-align: left;
  }


  i.close {
    font-size: 20px;
    float: right;
    margin-top: 24px;
  }

  .popup-lab {
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 18px;
  }

  .popup-btn {
    text-align: center;
    margin-top: 30px;
  }

  .popup-btn .el-button {
    padding: 0 34px !important;
    line-height: 34px !important;
    margin: 0 16px;
  }


  .echart-view {
    margin-top: 40px;
    height: 70%;
  }

  #Category {
    /* padding: 0 40px; */
  }

  .attr-title {
    background-color: #5087e4;
    font-size: 15px;
    color: #fff;
    line-height: 40px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    margin-bottom: 10px;
  }

  .attr {
    font-size: 14px;
    line-height: 32px;
  }

  .top-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 28%;
  }

  .top-box>div {
    width: 20%;
    height: 210px;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin:0 20px;
  }

  .scroll {
    width: 100%;
    height: 86% !important;
    overflow: auto;
    box-sizing: border-box;
  }
  #Category{
    height: 100%;
  }
  .scroll-box {
    height: 150px;
    overflow-y: auto;
  }

  .top-box>div p {
    padding: 0 20px;
  }

  .text {
    width: calc(100% - 98px);
    margin-left: 10px;
    line-height: 80px;
  }

  .img {
    width: 88px;
    height: 88px;
    /* margin-top: 10px; */
  }

  .item-title {
    font-size: 15px;
    border-bottom: 1px solid #dcdcdc;
    line-height: 34px;
  }

  .item-title span {
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-left: 5px;
    border-radius: 50%;
    margin-right: 10px;
    box-sizing: border-box;
    background-color: #40ffcb;
    box-shadow: 0 0 5px 1px #40ffcb;
  }

  .device-list {
    position: absolute;
    left: 0;
    bottom: 0;
    background: #fff;
    min-height: 717px;
    top: 61px;
    right: 0;
    padding: 10px 0;
    box-sizing: border-box;
    overflow-y: scroll;
    display: flex;
    flex-wrap: wrap;
    align-content: baseline;
    justify-content: flex-start;
  }

  .item {
    padding: 6px 14px;
    border-radius: 5px;
    height: 140px;
    width: 235px;
    margin: 10px 10px;
    box-sizing: border-box;
    border: 1px solid #dcdcdc;
    background-color: #fff;
  }

  .device-view {
    position: absolute;
    width: 100%;
    bottom: 20px;
    top: 0;
  }
  .device-top{
    height: 49%;
  }
  .content {
    position: absolute;
    left: 329px;
    right: 0;
    bottom: 0;
    top: 20px;
  }

  .type-box {
    float: left;
    height: 40px;
    overflow: hidden;
    background-color: #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border: 1px solid #d2d2d2;
    box-sizing: border-box;
  }

  .type-box div {
    float: left;
    padding: 9px 0;
    -webkit-transition: .1s;
    transition: .1s;
    cursor: pointer;
  }

  .type-box div.active {
    background: #5087e4;
    color: #fff;
  }

  .type-box>div:first-child span {
    border: none;
  }

  .type-box span {
    display: inline-block;
    width: 110px;
    font-size: 14px;
    line-height: 22px;
    border-left: 1px solid #e2e2e2;
    float: left;
  }

  .active>span {
    border: 0;
  }

  .device-list-content,
  .data-details {
    width: calc(100% - 20px);
    position: absolute;
    top: 40px;
    bottom: 20px;
    padding: 25px 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: left;
  }

  .data-details {
    background-color: #fff;
  }

  .btn-box2 {
    margin-left: 10px;
  }

  .btn-box {
    margin-top: 30px;
    text-align: center;
  }

  .no-border {
    border: none;
  }
  .num-unit{
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    position: relative;
    top: -2px;
  }
  .notData{
    position: absolute;
    top: 50%;
    width: 100%;
  }
</style>
<style type="text/css">
  #ElectricMonitor .tree .is-current>.el-tree-node__content {
    background-color: #dfdfdf !important;
  }

  /* 修改ele-ui 默认样式 */
  #ElectricMonitor .tree .el-tree-node__content .custom-tree-node {
    font-size: 14px !important;
    margin-left: 10px;
    position: relative;
    justify-content: stretch !important;
  }

  #ElectricMonitor .tree .el-tree-node__children .custom-tree-node {
    font-size: 14px !important;
    padding-right: 10px;
  }

  #ElectricMonitor .el-tree-node>.el-tree-node__children {
    overflow: unset !important;
  }

  #ElectricMonitor .tree .el-tree>.el-tree-node:after {
    border-top: none;
  }

  #ElectricMonitor .tree .el-tree-node {
    position: relative;
    padding-left: 16px;
  }

  #ElectricMonitor .tree .el-tree-node__content {
    background: #fff;
    padding-left: 0 !important;
  }

  /* //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉 */
  #ElectricMonitor .tree .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  #ElectricMonitor .tree .el-tree-node__children {
    padding-left: 16px;
  }

  #ElectricMonitor .tree .el-tree-node :last-child:before {
    height: 18px;
  }

  #ElectricMonitor .tree .el-tree>.el-tree-node:before {
    border-left: none;
  }

  #ElectricMonitor .tree .el-tree>.el-tree-node:after {
    border-top: none;
  }

  #ElectricMonitor .tree .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #ElectricMonitor .tree .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #ElectricMonitor .tree .el-tree-node:before {
    border-left: 1px dashed #dedede;
    bottom: 0px;
    height: 100%;
    top: -7px;
    width: 1px;
  }

  #ElectricMonitor .tree .el-tree-node:after {
    border-top: 1px dashed #dedede;
    height: 20px;
    top: 12px;
    width: 24px;
  }


  #ElectricMonitor .dashed .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #ElectricMonitor .dashed .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #ElectricMonitor .dashed .el-tree-node:before {
    border-left: 1px dashed #dedede;
    bottom: 0px;
    height: 100%;
    top: -7px;
    width: 1px;
  }

  #ElectricMonitor .dashed .el-tree-node:after {
    border-top: 1px dashed #dedede;
    height: 20px;
    top: 12px;
    width: 24px;
  }

  #ElectricMonitor .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Energy/ElectricMonitor.vue